import { defineCustomElement, ref, computed, watch } from 'vue/dist/vue.esm-bundler.js'
import { html } from './shared/functions'

const ImComponent = defineCustomElement({
  props: {
    step1Status: {
      type: String,
      default: ''
    },
    step2Status: {
      type: String,
      default: ''
    },
    step3Status: {
      type: String,
      default: ''
    },
    step4Status: {
      type: String,
      default: ''
    },
  },
  setup(props, { emit }) {
    return {
      step1Status: computed(() => props.step1Status),
      step2Status: computed(() => props.step2Status),
      step3Status: computed(() => props.step3Status),
      step4Status: computed(() => props.step4Status),
    }
  },
  template: html`
    <ol class="relative text-gray-500 border-s border-gray-200 dark:border-gray-700 dark:text-gray-400 ml-4">                  
      <li class="mb-8 ms-6">
        <span class="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4 ring-4 dark:ring-gray-900" :class="[step1Status === 'success' ? 'bg-green-200 dark:bg-green-900 ring-white' : step1Status === 'current' ? 'bg-white ring-green-200' : 'bg-gray-100 dark:bg-gray-700 ring-white']" >
          <template v-if="step1Status === 'success'">
            <svg class="w-3.5 h-3.5 text-green-500 dark:text-green-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
            </svg>  
          </template>
          <template v-else>
            <svg class="w-4 h-4 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd" d="M9 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4H7Zm8-1a1 1 0 0 1 1-1h1v-1a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 0 1-1-1Z" clip-rule="evenodd"/>
            </svg>
          </template>
        </span>
        <h3 class="font-medium leading-tight">예약자 인증</h3>
        <p class="text-xs text-gray-400">
          {{ step1Status === 'success' ? '인증되었습니다' : '인증대기' }}
        </p>
      </li>
      <li class="mb-8 ms-6">
        <span class="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4 ring-4 ring-white dark:ring-gray-900" :class="[step2Status === 'success' ? 'bg-green-200 dark:bg-green-900' : 'bg-gray-100 dark:bg-gray-700']">
          <template v-if="step2Status === 'success'">
            <svg class="w-3.5 h-3.5 text-green-500 dark:text-green-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
            </svg>  
          </template>
          <template v-else>
            <svg class="w-3.5 h-3.5 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 16">
              <path d="M18 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2ZM6.5 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3.014 13.021l.157-.625A3.427 3.427 0 0 1 6.5 9.571a3.426 3.426 0 0 1 3.322 2.805l.159.622-6.967.023ZM16 12h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2Zm0-3h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Zm0-3h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Z"/>
            </svg>
          </template>
        </span>
        <h3 class="font-medium leading-tight">사용자 입력</h3>
        <p class="text-xs text-gray-400">
          {{ step2Status === 'success' ? '입력완료' : '입력대기' }}
        </p>
      </li>
      <li class="mb-8 ms-6">
        <span class="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4 ring-4 ring-white dark:ring-gray-900" :class="[step3Status === 'success' ? 'bg-green-200 dark:bg-green-900' : 'bg-gray-100 dark:bg-gray-700']">
          <template v-if="step3Status === 'success'">
            <svg class="w-3.5 h-3.5 text-green-500 dark:text-green-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
            </svg>  
          </template>
          <template v-else>
            <svg class="w-3.5 h-3.5 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 20">
              <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z"/>
            </svg>
          </template>
        </span>
        <h3 class="font-medium leading-tight">시간/장소 입력</h3>
        <p class="text-xs text-gray-400">
          {{ step3Status === 'success' ? '입력완료' : '입력대기' }}
        </p>
      </li>
      <li class="ms-6">
        <span class="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4 ring-4 ring-white dark:ring-gray-900" :class="[step4Status === 'success' ? 'bg-green-200 dark:bg-green-900' : 'bg-gray-100 dark:bg-gray-700']">
          <template v-if="step4Status === 'success'">
            <svg class="w-3.5 h-3.5 text-green-500 dark:text-green-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
            </svg>  
          </template>
          <template v-else>
            <svg class="w-3.5 h-3.5 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 20">
              <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2ZM7 2h4v3H7V2Zm5.7 8.289-3.975 3.857a1 1 0 0 1-1.393 0L5.3 12.182a1.002 1.002 0 1 1 1.4-1.436l1.328 1.289 3.28-3.181a1 1 0 1 1 1.392 1.435Z"/>
            </svg>
          </template>
        </span>
        <h3 class="font-medium leading-tight">준비사항 입력</h3>
        <p class="text-xs text-gray-400">
          {{ step4Status === 'success' ? '입력완료' : '입력대기' }}
        </p>
      </li>
    </ol>
`,
},  { shadowRoot: false })

customElements.define('im-vertical-booking-stepper', ImComponent)
